/* ==========================================================================
  critical.js
========================================================================== */

/**
 * Before lazyloaded image is loaded
 */
document.addEventListener('lazybeforeunveil', function(e){

  // current <img> element
  var el = e.target;

  /**
   * Hide possible pre-load image when current image is loaded:
   * <img class="lazyload"> <-- actual image
   * <img class="lazyload-preload"> <-- preload image
   */
  el.addEventListener('load', function(e) {
    var preload = this.parentNode.querySelector('.lazyload-preload');
    if (preload) {
      preload.classList.add('lazyload-preload--ready');
    }
  });

});

/**
 * Notification bar and cookie
 */

function setUserCookie(cvalue) {
  var d = new Date();
  var element = document.getElementById("notification");
  var menu = document.getElementById("masthead");
  var content = document.getElementById("content");
  var mobilemenu = document.getElementById("mobile-menu");

  sessionStorage['cvalue'] = cvalue;

  element.classList.add("hidden");
  menu.classList.add("js-margin");
  content.classList.add("js-margin");
  mobilemenu.classList.add("js-margin");
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
      c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
      }
  }
  return "";
}

function checkCookie(onpageload) {
  var user = sessionStorage['cvalue'];
  var element = document.getElementById("notification");
  var menu = document.getElementById("masthead");
  var content = document.getElementById("content");
  var mobilemenu = document.getElementById("mobile-menu");

  if (user != undefined) {
    element.classList.add("hidden");
    menu.classList.add("js-margin");
    content.classList.add("js-margin");
    mobilemenu.classList.add("js-margin");
  } else {
    element.classList.remove("hidden");
    menu.classList.remove("js-margin");
    content.classList.remove("js-margin");
    mobilemenu.classList.remove("js-margin");
    if (!onpageload) {
      setUserCookie("user");
    }
  }
}

